// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fUyl","footer":"styles_footer__34Xx_"};